// Global state for the app

// initial state
const state = {
  snackbar: false,
  snackbarMsg: null,
  showError: false,
  errorMessage: null,
  httpError: [], // NEW, store HTTP error
  // postErrorLog: false,
  isPrintMode: false
}

const actions = {
  // To support muti snackbarMsg trigger in a short time,
  // change it from mutation to action
  // snackbarMsg: String
  setSnackbarMsg ({ commit }, snackbarMsg) {
    commit('setSnackbar', false)
    commit('setSnackbarMsg', snackbarMsg)
    setTimeout(() => {
      commit('setSnackbar', true)
    }, 50)
  },

  setErrorMessage ({ commit }, msg) {
    commit('setErrorMessage', msg)
    setTimeout(() => {
      commit('setShowError', true)
    }, 50)
  }
}

// mutations
const mutations = {
  // snackbarMsg: String
  setSnackbarMsg (state, snackbarMsg) {
    // state.snackbar = false
    state.snackbarMsg = snackbarMsg
    // $store.commit('global/setSnackbar', true)
  },
  // val: Boolean
  setSnackbar (state, val) {
    state.snackbar = val
  },

  setErrorMessage (state, val) {
    state.errorMessage = val
  },

  setHttpError (state, val) {
    state.httpError.push(val)
  },

  clearHttpError (state) {
    state.httpError = []
  },

  setShowError (state, val) {
    state.showError = val
  },

  // setPostErrorLog (state, val) {
  //   state.postErrorLog = val
  // },

  setPrintMode (state, val) {
    state.isPrintMode = val
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
